import React from "react";
import { useSelector } from "react-redux";
import { Action, ActionsPopup } from "../../../../../UI/ActionsPopup";
import DragAndDropStudentList from "../../shared/DragAndDropStudentList/DragAndDropStudentList";
import classes from './Team.module.css';
import { submissionStatusEnum, submissionStatusTextEnum } from "../../../../../../models/SubmissionStatusEnum";
const Team = ({ listId, items, searchTerm, submissionStatus, deleteTeam }) => {
    const { texts } = useSelector(state => state.translate);

    return (
        <div className={classes.Team}>
            <div className={classes.Title}>{texts.team} {listId}</div>

            {submissionStatus == submissionStatusTextEnum.finalScored && <div className={classes.Tooltip}>
                <span className={classes.tooltipText}>{texts.teamIsFinalSubmissionScored}</span>
            </div>}
            {submissionStatus !== submissionStatusTextEnum.finalScored && items?.length ? <ActionsPopup dropClass={classes.Dots}>
                <Action onClick={() => deleteTeam(listId)}>{texts.deleteTeam}</Action>
            </ActionsPopup> : ''}
            <div className={classes.List}>
                <DragAndDropStudentList submissionStatus={submissionStatus} listId={listId} items={items} searchTerm={searchTerm} draggableClass={classes.Student} />
            </div>
        </div>
    )
}

export default Team;